import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Tooltip,
  ModalFooter,
} from "@chakra-ui/react";
import ServiceSelectNew from "../select/ServiceSelectNew";
import { useTranslation } from "react-i18next";
import {
  backgroundLight,
  newBorder,
  primaryAlt,
  textPrimary,
  textSecondary,
  white,
} from "../../utils/colors";
import { Button, Flex, Icon, IconButton, Text } from "@chakra-ui/react";
import { FaLock, FaLockOpen, FaXmark } from "react-icons/fa6";
import TreatmentPlanSelectNew from "../select/TreatmentPlanSelectNew";

const AddTreatmentPlanModal = ({
  patientId,
  patientName,
  addTreatmentPlanModalOpen,
  setAddTreatmentPlanModalOpen,
  handlePlanSelect,
  selectedPlans,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal
        isOpen={addTreatmentPlanModalOpen}
        onClose={() => setAddTreatmentPlanModalOpen(false)}
        isCentered
        autoFocus={false}
        scrollBehavior="inside"
        blockScrollOnMount={false}
      >
        <ModalOverlay />
        <ModalContent borderRadius="1.5rem" w="100%" minW="600px">
          <ModalHeader p="1rem 1.5rem" borderBottom={`1px solid ${newBorder}`}>
            <Flex w="100%" align="center" justify="space-between">
              <Text fontSize="1rem" fontWeight="600" color={textPrimary}>
                {t("treatmentPlan.selectTreatmentPlans")}
              </Text>
              <Flex align="center" justify="flex-end" gap="1.5rem">
                <IconButton
                  size="sm"
                  bg={backgroundLight}
                  color={textSecondary}
                  onClick={() => setAddTreatmentPlanModalOpen(false)}
                  borderRadius="10rem"
                  _hover={{ bg: primaryAlt, color: white }}
                >
                  <Icon as={FaXmark} />
                </IconButton>
              </Flex>
            </Flex>
          </ModalHeader>

          <ModalBody p="1.5rem 1.5rem 2rem">
            <TreatmentPlanSelectNew
              patientId={patientId}
              patientName={patientName}
              selectedPlans={selectedPlans}
              onChange={handlePlanSelect}
            />
          </ModalBody>

          <ModalFooter
            p="0rem 1.5rem 1.5rem"
            borderTop={`0px solid ${newBorder}`}
          >
            <Flex align="center" justify="center" w="100%" gap="1rem">
              <Button
                minW="6rem"
                size="md"
                fontSize="sm"
                bg={backgroundLight}
                color={textSecondary}
                onClick={() => setAddTreatmentPlanModalOpen(false)}
                borderRadius="10rem"
                _hover={{ bg: primaryAlt, color: white }}
              >
                {t("button.close")}
              </Button>
              <Button
                minW="6rem"
                size="md"
                fontSize="sm"
                bg={textPrimary}
                color={white}
                onClick={() => setAddTreatmentPlanModalOpen(false)}
                borderRadius="10rem"
                _hover={{ bg: primaryAlt, color: white }}
              >
                Ok
              </Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AddTreatmentPlanModal;
